__turbopack_context__.v({
  "bannerCollapse": "Header-module__e62msq__bannerCollapse",
  "bar": "Header-module__e62msq__bar",
  "barAndPanel": "Header-module__e62msq__barAndPanel",
  "barInner": "Header-module__e62msq__barInner",
  "center": "Header-module__e62msq__center",
  "compactLogo": "Header-module__e62msq__compactLogo",
  "desktopOnly": "Header-module__e62msq__desktopOnly",
  "iconButton": "Header-module__e62msq__iconButton",
  "left": "Header-module__e62msq__left",
  "menuScrim": "Header-module__e62msq__menuScrim",
  "mobileOnly": "Header-module__e62msq__mobileOnly",
  "navButton": "Header-module__e62msq__navButton",
  "navLabel": "Header-module__e62msq__navLabel",
  "navLink": "Header-module__e62msq__navLink",
  "navList": "Header-module__e62msq__navList",
  "navListItem": "Header-module__e62msq__navListItem",
  "right": "Header-module__e62msq__right",
  "slimCta": "Header-module__e62msq__slimCta",
  "wrapper": "Header-module__e62msq__wrapper",
});
